module.exports = __webpack_public_path__ + "static/media/BANNER_MOBILE.3b60e30c.png";